import { z } from "zod";

/** Patient intelligence — deterministic care-gap alerts + lab trends. */

export const patientIntelAlertSchema = z.object({
	severity: z.enum(["critical", "warning", "info"]),
	/** rule key: recall_due | diabetes_hba1c_overdue | htn_followup_overdue | critical_unrechecked */
	kind: z.string(),
	/** free context (e.g. recall reason or test name); may be empty. */
	message: z.string(),
	detail: z.string().nullable(),
});
export type PatientIntelAlert = z.infer<typeof patientIntelAlertSchema>;

export const patientIntelTrendSchema = z.object({
	test_name: z.string(),
	direction: z.enum(["up", "down", "stable"]),
	from: z.number(),
	to: z.number(),
	pct: z.number(),
	latest_flag: z.string(),
	readings: z.number().int(),
});
export type PatientIntelTrend = z.infer<typeof patientIntelTrendSchema>;

export const patientIntelligenceResponseSchema = z.object({
	patient_id: z.string().uuid(),
	generated_at: z.string().datetime(),
	alerts: z.array(patientIntelAlertSchema),
	trends: z.array(patientIntelTrendSchema),
});
export type PatientIntelligenceResponse = z.infer<
	typeof patientIntelligenceResponseSchema
>;
